export function animatedNumbers(isDesktop) {
    if(isDesktop) {
        const numbers = $(".animated-number");
        
        //if there are no dots in number
        function numberWithCommas(x) {
            return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        }

        numbers.each(function (i, item) {
            $(item).prop("Counter", 0)
                .attr("data-number", $(item).text().replace(/[^0-9]/g, ""))
                .text("0");

            $(item).animate({
                Counter: $(item).attr("data-number"),
            }, {
                duration: 2000,
                easing: "swing",
                step: function (now) {
                    $(item).text(numberWithCommas(Math.ceil(now)));
                }
            });
        });
    }
}


// WEBPACK FOOTER //
// ./assets/js/modules/animated-numbers.js